import React, { useContext, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { PageTitle } from "../../../_metronic/layout/core";
import { SaleEntryForm } from "./SaleEntryForm";
import BedRockContext from "../../BedRockContext";

export function SaleEntryPage() {
    const { id } = useParams();
    const location = useLocation();
    const myData = useContext(BedRockContext);

    // Check if this is view mode (read-only) based on URL path
    const isViewMode = location.pathname.includes('/view/');
    const isEditMode = Boolean(id) && !isViewMode;
    const pageTitle = isViewMode ? "View Sale" : (isEditMode ? "Edit Sale" : "New Sale Entry");

    // Reset toolbar buttons when entering this page
    useEffect(() => {
        myData.setBaseData({ toolBarButtons: [] });
    }, []);

    const breadcrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
        {
            title: "Sales",
            path: "/sale",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>{pageTitle}</PageTitle>
            <SaleEntryForm id={id} readOnly={isViewMode} />
        </>
    );
}
